/* eslint-disable no-prototype-builtins */
import * as React from 'react'
import axios from 'axios'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'

import { positionChangeHeightSm, positionChangeWidthMd, positionChangeWidthSm, swipelyticsPink, profileTypes, profileVibes, promptsArray } from '../../../../helpers/variableDefaults'
import { standardButton, exitModalIconButton } from '../../../../helpers/buttons'
import { modifyInDatabase } from '../../../../helpers/modifyInDatabase'
import { newSimulationTextField, descriptionTextField, descriptionTextFieldNoIndexOrChangeHandler } from '../../../../helpers/textfields'
import { validEmail, removeDuplicatesFromArray, noDuplicatesInArray, capitalizeFirstLetter } from '../../../../helpers/globalHelpers'
import { standardErrorContainer } from '../../../../helpers/errors'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { selectElementHandleChange, selectMultiple, selectElementWithIndex, selectCustomElementString } from '../../../../helpers/selects'
import { doneAndCancelButtonsJSX } from '../../../../helpers/commonJSX'
import { advisoryTypography } from '../../../../helpers/typographies'

export const selectPromptModalJSX = (
  user, 
  datingProfile, setDatingProfile, 
  previousDatingProfile, setPreviousDatingProfile, 
  selectedPromptIndex, setSelectedPromptIndex,
  newPrompt, setNewPrompt,
  openPromptSelectModal, setOpenPromptSelectModal,
  customPromptSelected, setCustomPromptSelected,
  loading, setLoading,
  errors, setErrors,
  saveSuccessful, setSaveSuccessful,
  width
) => {

  // console.log('user.bio.prompts ->', user.bio.prompts)
  const arrayOfPrompts = removeDuplicatesFromArray([ 
    { prompt: 'No Prompt', response: 'No Response' }, 
    ...user.bio.prompts,
    // { prompt: `${newPrompt.prompt}`, response: `${newPrompt.response}` },
    { prompt: 'Custom', response: 'Create a custom prompt and response' }  
  ]).filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0)
  if (datingProfile.bio.prompts[selectedPromptIndex].prompt.length > 0 && arrayOfPrompts.filter((promptInArray, promptInArrayIndex) => promptInArray.prompt === datingProfile.bio.prompts[selectedPromptIndex].prompt && promptInArray.response === datingProfile.bio.prompts[selectedPromptIndex].response).length === 0) {
    arrayOfPrompts.splice(arrayOfPrompts.length - 1, 0, { prompt: `${datingProfile.bio.prompts[selectedPromptIndex].prompt}`, response: `${datingProfile.bio.prompts[selectedPromptIndex].response}` })
  }
  // console.log('arrayOfPrompts ->', arrayOfPrompts)
  // console.log('newPrompt ->', newPrompt)

  const allDefaultPromptsAreUsed = () => {
    if (
      user.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length > 0
      && datingProfile.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length > 0
    ) {
      const userPromptsArray = user.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).map(promptObj => promptObj.prompt)
      const userResponsesArray = user.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).map(promptObj => promptObj.response)
      const datingProfilePromptsArray = datingProfile.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).map(promptObj => promptObj.prompt)
      const datingProfileResponsesArray = datingProfile.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).map(promptObj => promptObj.response)
      for (let i = 0; i < userPromptsArray.length; i++) {
        // for (let x = 0; x < datingProfile.bio.prompts.length; x++) {
        // console.log('user.bio.prompts ->', user.bio.prompts)
        // console.log('datingProfile.bio.prompts ->', datingProfile.bio.prompts)
        // console.log(' ->', user.bio.prompts[i])
        // console.log(datingProfilePromptsArray.includes(userPromptsArray[i]))
        // console.log(datingProfileResponsesArray.includes(userResponsesArray[i]))
        if (
          !datingProfilePromptsArray.includes(userPromptsArray[i])
          || !datingProfileResponsesArray.includes(userResponsesArray[i])
          // 'prompt' in user.bio.prompts[i]
          // && user.bio.prompts[i].prompt.length > 0
          // && 'response' in user.bio.prompts[i]
          // && user.bio.prompts[i].response.length > 0
          // && 'prompt' in datingProfile.bio.prompts[x]
          // && datingProfile.bio.prompts[x].prompt.length > 0
          // && 'response' in datingProfile.bio.prompts[x]
          // && datingProfile.bio.prompts[x].response.length > 0
        ) {
          return false
        }
        // }
      }
      return true
    } else if (
      user.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length > 0
    ) {
      return false
    } else if (
      datingProfile.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length > 0
    ) {
      return true
    } else {
      return true
    }
  }

  const handleClose = () => {
    // console.log('handleClose runs ->')
    // console.log('openMediaItemSelectModal ->', openMediaItemSelectModal)

    setNewPrompt({})
    setSelectedPromptIndex(-1)
    setCustomPromptSelected(false)
    setOpenPromptSelectModal(false)
  }

  const handleDone = async () => {
    console.log('handleDone runs')
    
    const newPrompts = [ ...datingProfile.bio.prompts ] 
    // console.log('newPrompt.response.length ->', newPrompt.response.length)
    newPrompts[selectedPromptIndex] = newPrompt.response.length > 0 ? { ...newPrompt } : { prompt: '', response: '' }
    
    if (newPrompts[selectedPromptIndex].prompt === 'No Prompt' || newPrompts[selectedPromptIndex].prompt === '') {
      // console.log('no prompt')
      newPrompts.splice(selectedPromptIndex, 1)
      newPrompt.response.length > 0 ? newPrompts.push({ ...newPrompt }) : newPrompts.push({ prompt: '', response: '' })
    } 
    // console.log('newPrompts ->', newPrompts)
    const newBio = { ...datingProfile.bio, prompts: [ ...newPrompts ] }
    setDatingProfile({ ...datingProfile, bio: { ...newBio } })

    setNewPrompt({})
    setSelectedPromptIndex(-1)
    setCustomPromptSelected(false)
    setOpenPromptSelectModal(false)
  }

  const selectPrompt = (e, promptIndexOnArray) => {
    e.preventDefault()
    // console.log('selectMediaItem runs')

    if (arrayOfPrompts[promptIndexOnArray].prompt !== 'Custom') {

      const newPrompts = [ ...datingProfile.bio.prompts ] 
      newPrompts[selectedPromptIndex] = { 
        prompt: arrayOfPrompts[promptIndexOnArray].prompt === 'No Prompt' ? '' : arrayOfPrompts[promptIndexOnArray].prompt,
        response: arrayOfPrompts[promptIndexOnArray].prompt === 'No Prompt' ? '' : arrayOfPrompts[promptIndexOnArray].response,
      }
      // console.log('newPrompts ->', newPrompts)
      // console.log('newPrompts[selectedPromptIndex] ->', newPrompts[selectedPromptIndex])
      if (newPrompts[selectedPromptIndex].prompt === 'No Prompt' || newPrompts[selectedPromptIndex].prompt === '') {
        // console.log('prompt should be removed')
        newPrompts.splice(selectedPromptIndex, 1)
        newPrompts.push({ prompt: '', response: '' })
      }
      // console.log('newPrompts ->', newPrompts)
      const newBio = { ...datingProfile.bio, prompts: [ ...newPrompts ] }
      setDatingProfile({ ...datingProfile, bio: { ...newBio } })

      setNewPrompt({})
      setSelectedPromptIndex(-1)
      setCustomPromptSelected(false)
      setOpenPromptSelectModal(false)
    } else {
      setNewPrompt({
        prompt: datingProfile.bio.prompts[selectedPromptIndex].prompt,
        response: datingProfile.bio.prompts[selectedPromptIndex].response,
      })
      setCustomPromptSelected(true)
    }

  }


  const doneButtonDisabled = () => {
    return (
      datingProfile.bio.prompts.length > selectedPromptIndex
        ?
        (
          newPrompt.prompt === datingProfile.bio.prompts[selectedPromptIndex].prompt
          && newPrompt.response === datingProfile.bio.prompts[selectedPromptIndex].response
        )
        :
        (
          newPrompt.prompt.length === 0
          && newPrompt.response.length === 0
        )
    )
  }

  const promptOnDatingProfile = (selectedPrompt, selectedPromptIndexOnArray) => {
    return datingProfile.bio.prompts.filter((datingProfilePrompt, datingProfilePromptIndex) => datingProfilePrompt.prompt === selectedPrompt.prompt && datingProfilePrompt.response === selectedPrompt.response).length > 0
  }

  const promptIsSelected = (selectedPromptIndexOnArray) => {
    return (
      (
        newPrompt.prompt === arrayOfPrompts[selectedPromptIndexOnArray].prompt
        || 
        (
          newPrompt.prompt === ''
          && arrayOfPrompts[selectedPromptIndexOnArray].prompt === 'No Prompt'
        )
      )
      && 
      (
        newPrompt.response === arrayOfPrompts[selectedPromptIndexOnArray].response
        ||
        (
          newPrompt.response === ''
          && arrayOfPrompts[selectedPromptIndexOnArray].response === 'No Response'
        )
      )
    )
  }

  const promptIsIndexSelected = (selectedPrompt) => {
    return (
      selectedPromptIndex < datingProfile.bio.prompts.length
      && selectedPrompt.prompt === datingProfile.bio.prompts[selectedPromptIndex].prompt
      && selectedPrompt.response === datingProfile.bio.prompts[selectedPromptIndex].response
    )
  }

  const promptItemsJSX = () => {
    return (
      <>
        {arrayOfPrompts.map((promptOnArray, promptIndexOnArray) => (
          <Box
            key={promptIndexOnArray}
            // onClick={((e) => selectPrompt(e, promptIndexOnArray))}
            onClick={(promptOnDatingProfile(promptOnArray, promptIndexOnArray) && !(promptIsIndexSelected(promptOnArray))) ? ((e) => e) : ((e) => selectPrompt(e, promptIndexOnArray))}
            disabled={(promptOnDatingProfile(promptOnArray, promptIndexOnArray) && !(promptIsIndexSelected(promptOnArray)))}
            sx={{
              mt: 2,
              width: width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px',
              backgroundColor: 'white',
              boxShadow: 3, 
              borderRadius: '5px',
              border: promptIsSelected(promptIndexOnArray) ? 2 : (promptOnDatingProfile(promptOnArray, promptIndexOnArray) && !(promptIsIndexSelected(promptOnArray))) ? 2 : 0,
              borderColor: promptIsSelected(promptIndexOnArray) ? 'blue' : (promptOnDatingProfile(promptOnArray, promptIndexOnArray) && !(promptIsIndexSelected(promptOnArray))) ? 'gray' : 'black',
              cursor: (promptOnDatingProfile(promptOnArray, promptIndexOnArray) && !(promptIsIndexSelected(promptOnArray))) || promptIsSelected(promptIndexOnArray) ? '' : 'pointer',
            }}
          >
            {/* Prompt */}
            <Box
              sx={{
                pt: 2, px: 2,
                fontWeight: 'bold',
                borderRadius: '5px 5px 0px 0px', 
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
              }}
            >
              {promptOnArray.prompt}
            </Box>

            {/* Response */}
            <Box
              sx={{
                pt: 1, pb: 2, px: 2,
                borderRadius: '5px 5px 0px 0px', 
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
              }}
            >
              {promptOnArray.response}
            </Box>
          </Box>
        ))}
      </>
    )
  }

  return (
    <Modal
      open={openPromptSelectModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      keepMounted
      sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}
    >
      <Box 
        sx={{ 
          // position: 'absolute',
          // left: '50%',
          // top: '50%',
          // transform: 'translate(-50%, -50%)',
          // width: width < positionChangeWidthSm ? '85%' : '450px',
          width: '85%',
          height: '85%',
          bgcolor: 'white',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4, 
          overflowY: 'scroll',
          '&::-webkit-scrollbar': {
            WebkitAppearance: 'none',
            width: '8px',
          },
          '&::-webkit-scrollbar-thumb': {
            borderRadius: '4px',
            backgroundColor: 'rgba(0, 0, 0, .35)',
            webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
          },
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%', height: '100%',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
          }}
        >
          {/* Exit Icon Button */}
          <Box
            sx={{
              mr: 0,
              width: '100%',
              display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center',
            }}
          >
            {exitModalIconButton(handleClose, false, 0, 1, 1)}
          </Box>

          {/* Title */}
          <Typography
            sx={{
              mt: 2,
              // mb: -2, 
              fontSize: '22px',
              fontWeight: 'bold',
            }}
          >
            Select Prompt
          </Typography>

          <Box
            sx={{
              my: -2,
              width: '100%',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
            }}
          >
            {advisoryTypography(
              `Prompts and Responses can be edited in the 'Bio' tab of your dashboard`
            )}
          </Box>


          {/* List of Prompts */}
          {!customPromptSelected && !allDefaultPromptsAreUsed() ? 
            promptItemsJSX()
            :
            <Box
              sx={{
                mt: 2,
                width: '95%', maxWidth: '400px',
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
              }}
            >
              {/* Prompt Select */}
              {selectCustomElementString(
                'prompt',
                `Prompt`,
                datingProfile.bio.prompts[selectedPromptIndex].prompt === '' ? 'Select a prompt' : newPrompt.prompt,
                false,
                true,
                datingProfile.bio.prompts[selectedPromptIndex].prompt === '' ? [ 'Select a prompt', ...promptsArray ] : promptsArray,
                newPrompt,
                setNewPrompt,
                width,
                0,
                0,
                'white'
              )}

              {/* Response */}
              {descriptionTextFieldNoIndexOrChangeHandler(
                'response',
                newPrompt.response,
                ``,
                3,
                150,
                'Your wittiest response',
                false,
                setNewPrompt,
                newPrompt,
                0
              )}
            </Box>
          }

          
          {/* Create and Cancel Buttons */}
          {doneAndCancelButtonsJSX(
            'Done',
            'Cancel',
            doneButtonDisabled(),
            false,
            handleDone,
            handleClose,
            0,
            0,
            0,
            width,
            'warning',
            'secondary'
          )}

          {errors.selectPrompt &&
            standardErrorContainer(
              'There was an error updating your prompt. Check your Internet connection and try again.',
              1,
              1
            )
          }
        </Box>
      </Box>
    </Modal>
  )
}